export default "__VITE_ASSET__cc88657a__"